import script from "./unread-count.vue?vue&type=script&lang=ts&setup=true"
export * from "./unread-count.vue?vue&type=script&lang=ts&setup=true"

import "./unread-count.vue?vue&type=style&index=0&id=3139d4ec&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3139d4ec"]])

export default __exports__